export default __webpack_public_path__ + "static/triodos-d3f5b1ea7498d8b0c109836c5e91c69e.svg";